import React, {useEffect, useState} from 'react'
import ReactSelect from 'react-select'
import PropTypes from 'prop-types'
import actions from 'redux-auto'
import Api from '#services/api'
import AzubiProfile from './AzubiProfile'
import {routeHelper} from '#config/routeKeys'
import TaskList from '#components/m/Status/TaskList'
import Option from '#components/m/Status/StatusSelectOption'
import SingleValue from '#components/m/Status/StatusSelectSingleValue'
import MenuList from '#components/m/Status/StatusSelectMenuList'
import Loading from '#components/a/Loading'
import {useNavigate} from 'react-router-dom'

const StatusSelect = ({canViewPraxisaufgabenFromOthers, user}) => {
  const [selectedAbteilungsId, setSelectedAbteilungsId] = useState(undefined)
  const [optionList, setOptionList] = useState(undefined)
  const [actBgColor, setActBgColor] = useState('#ffffff')
  const [actTextColor, setActTextColor] = useState('#000000')
  const [currentPos, setCurrentPos] = useState(undefined)
  const [isDataFetched, setIsDataFetched] = useState(false)

  const navigate = useNavigate()
  const loadSelectForAbteilungsID = async () => {
    try {
      const result = await Api.getPraxisaufgaben(user.id)
      const {currentAbteilungId, abteilungStatus} = result
      if (abteilungStatus.length === 0) {
        setIsDataFetched(true)
        return
      }

      const newOptions = abteilungStatus.map(item => {
        const {id, name, ...remaining} = item
        remaining.value = id
        remaining.label = name
        return remaining
      })

      const fallbackId = newOptions[0]?.value
      const abteilungsId = getAbteilungsId(selectedAbteilungsId, currentAbteilungId, fallbackId)

      let currentPosition = newOptions.findIndex(option => option.value === abteilungsId)
      if (currentPosition === -1) {
        currentPosition = 0
      }

      const currentAbteilung = newOptions[currentPosition]

      setOptionList(newOptions)
      setSelectedAbteilungsId(abteilungsId)
      setCurrentPos(currentPosition)
      setActBgColor(currentAbteilung?.backgroundColor)
      setActTextColor(currentAbteilung?.textColor)
      setIsDataFetched(true)
    } catch (e) {
      actions.error.writeError({error: e})
    }
  }

  useEffect(() => {
    loadSelectForAbteilungsID()
  }, [selectedAbteilungsId, user])

  const getAbteilungsId = (selectedId, currentId, fallbackId) => {
    if (!selectedId) {
      if (currentId === 0) {
        return fallbackId
      }
      return currentId
    }
    return selectedId
  }

  const handleChange = selectedOption => {
    setActBgColor(selectedOption.backgroundColor)
    setActTextColor(selectedOption.textColor)
    setSelectedAbteilungsId(selectedOption.value)
  }

  const handleAufgabenUpdated = (abteilungId, aufgabenList) => {
    setOptionList(
      optionList.map(o =>
        o.value === abteilungId
          ? {
              ...o,
              tasksTotal: aufgabenList.filter(task => !task.archived).length,
              tasksDone: aufgabenList.filter(task => !task.archived && task.done).length,
            }
          : o,
      ),
    )
  }

  const handleOnAzubiProfileClick = azubiId => {
    navigate(routeHelper.praxisaufgabenDetail(azubiId))
  }

  const colourStyles = {
    control: styles => ({
      ...styles,
      backgroundColor: actBgColor,
    }),
    singleValue: styles => ({
      ...styles,
      color: actTextColor,
    }),
    dropdownIndicator: styles => ({
      ...styles,
      color: actTextColor,
    }),
  }

  const isLoading = optionList === undefined && selectedAbteilungsId === undefined && !isDataFetched

  const hasNoPraxisaufgaben = optionList === undefined && selectedAbteilungsId === undefined && isDataFetched

  if (hasNoPraxisaufgaben) {
    return null
  }

  const {id} = user
  return (
    <div
      data-testid="azubi-status-select"
      className="statusselect"
      style={!canViewPraxisaufgabenFromOthers ? {width: '748px'} : null}>
      {canViewPraxisaufgabenFromOthers && <AzubiProfile user={user} onClick={() => handleOnAzubiProfileClick(id)} />}
      {isLoading ? (
        <Loading />
      ) : (
        <div data-testid="statusSelect">
          <ReactSelect
            options={optionList}
            defaultValue={optionList[currentPos]}
            value={optionList.find(o => o.value === selectedAbteilungsId)}
            onChange={handleChange}
            styles={colourStyles}
            aria-labelledby={id}
            id={id}
            name={id}
            components={{Option, SingleValue, MenuList}}
            placeholder="Bitte wählen..."
            className="react-select"
            classNamePrefix="react-select"
          />
          <TaskList
            userId={id}
            currentAbteilungId={selectedAbteilungsId}
            onAufgabenUpdated={handleAufgabenUpdated}
            backgroundColor={actBgColor}
          />
        </div>
      )}
    </div>
  )
}

StatusSelect.propTypes = {
  user: PropTypes.object,
  canViewPraxisaufgabenFromOthers: PropTypes.bool,
}

export default StatusSelect
